var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAclDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 4C21.5 3.17157 20.8284 2.5 20 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V20C2.5 20.8284 3.17157 21.5 4 21.5H20C20.8284 21.5 21.5 20.8284 21.5 20V4ZM4 4H7.75V20H4V4ZM9.25 20V4H20V20H9.25ZM17.65 7C17.65 6.58579 17.3142 6.25 16.9 6.25H12.1L11.9982 6.25685C11.6322 6.30651 11.35 6.6203 11.35 7C11.35 7.41421 11.6858 7.75 12.1 7.75H16.9L17.0018 7.74315C17.3678 7.69349 17.65 7.3797 17.65 7ZM16.9 13.25C17.3142 13.25 17.65 13.5858 17.65 14C17.65 14.3797 17.3678 14.6935 17.0018 14.7432L16.9 14.75H12.1C11.6858 14.75 11.35 14.4142 11.35 14C11.35 13.6203 11.6322 13.3065 11.9982 13.2568L12.1 13.25H16.9ZM17.65 10.5C17.65 10.0858 17.3142 9.75 16.9 9.75H12.1L11.9982 9.75685C11.6322 9.80651 11.35 10.1203 11.35 10.5C11.35 10.9142 11.6858 11.25 12.1 11.25H16.9L17.0018 11.2432C17.3678 11.1935 17.65 10.8797 17.65 10.5Z",
    fill: "#B2B7C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAclDefault);
export default __webpack_public_path__ + "static/media/aclDefault.e2f515ad5eb4be47302e81675b139fe8.svg";
export { ForwardRef as ReactComponent };